export { default as ProductViewHeading } from './ProductViewHeading';
